import type { SxProps } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { INK } from "../../../../theme/tokens";

/** The popup's small field labels and helper lines. */
export const smallLabelTypographySx: SxProps = {
	fontWeight: 500,
	fontStyle: "normal",
	fontSize: "12px",
	lineHeight: "14px",
	letterSpacing: "0px",
	verticalAlign: "middle",
	color: alpha(INK.SECONDARY, 0.6),
} as const satisfies SxProps;
